<script>
  import AddressStore from './stores.js';

	export let address;
  const addresses = {};

  async function delete_address() {
    let addresses = $AddressStore;
    delete addresses[address];
    AddressStore.set(addresses);
  }
</script>

<button class="bg-red-600 text-white rounded p-2" on:click={delete_address}>
  Delete
</button>

